import { render } from "./SystemBanner.vue?vue&type=template&id=6f80c0be"
import script from "./SystemBanner.vue?vue&type=script&lang=js"
export * from "./SystemBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__